import { useEffect } from 'react';
import { useSessionStore } from '@/stores/session-store';

/** Dữ liệu cũ hơn mức này thì quay lại thẻ là nạp lại. */
export const STALE_AFTER_MS = 5 * 60_000;

/**
 * Giữ dữ liệu ĐỦ MỚI cho người để thẻ mở cả ngày.
 *
 * Dữ liệu nạp một lần lúc đăng nhập (bản cũ cũng vậy): phần người khác nhập sau đó không tự hiện ra.
 * Với vài người thì F5 là xong; với cả trăm người nhập liệu, quản lý mở bảng tổng hợp từ sáng sẽ đọc
 * số của buổi sáng suốt cả ngày mà không biết. Ở đây, mỗi lần người dùng QUAY LẠI thẻ (đổi thẻ, mở
 * lại cửa sổ) mà dữ liệu đã cũ quá 5 phút thì nạp lại ngầm — không hỏi vòng liên tục, không tốn gì
 * khi không ai nhìn. Bản nháp đang gõ nằm ở store riêng nên không bị ảnh hưởng.
 */
export function useWorkspaceRefresh(): void {
  useEffect(() => {
    // Quay lại thẻ thường bắn CẢ HAI sự kiện (visibilitychange + focus) — chỉ nạp một lượt.
    let refreshing = false;
    const refreshIfStale = () => {
      if (refreshing || document.visibilityState !== 'visible') return;
      const { status, loadedAt, reload } = useSessionStore.getState();
      if (status !== 'authenticated' || Date.now() - loadedAt < STALE_AFTER_MS) return;
      refreshing = true;
      reload()
        // Mất mạng thì thôi — lần quay lại sau sẽ thử tiếp; phiên hết hạn đã có tầng API lo.
        .catch(() => undefined)
        .finally(() => {
          refreshing = false;
        });
    };
    document.addEventListener('visibilitychange', refreshIfStale);
    window.addEventListener('focus', refreshIfStale);
    return () => {
      document.removeEventListener('visibilitychange', refreshIfStale);
      window.removeEventListener('focus', refreshIfStale);
    };
  }, []);
}
